// Users domain mappers.
export const VALID_TIMEZONES = ["PKT", "GMT", "UTC", "EST", "CST", "MST", "PST"];

export const normalizeTimezone = (timezone) =>
  timezone && VALID_TIMEZONES.includes(timezone) ? timezone : "UTC";

const mapSmsNotification = (val) => {
  if (val === true || val === "true") return "Enabled";
  return "Disabled";
};

export const toUIUser = (apiUser) => {
  const rawVoicemailId = Number(apiUser.voicemail_number_id);
  const voicemailNumberId =
    Number.isFinite(rawVoicemailId) && rawVoicemailId > 0 ? rawVoicemailId : null;

  return {
    id: apiUser.id,
    client_id: apiUser.client_id ?? null,
    firstName: apiUser.firstname || "",
    lastName: apiUser.lastname || "",
    toAddress: apiUser.pbx_email || "",
    deliveryAddress: apiUser.email || "",
    emailMode: apiUser.user_status === "enabled" ? "Enabled" : "Disabled",
    smsMode: mapSmsNotification(apiUser.sms_notification),
    mobileNumber: apiUser.phone || "",
    voicemailNumber: "",
    voicemailNumberId,
    timeZone: normalizeTimezone(apiUser.timezone),
    userRole: apiUser.user_role || "",
    userType: apiUser.user_type || "",
    twoFaEnabled: apiUser.two_fa_enabled ?? false,
    createdAt: apiUser.created_at || "",
    updatedAt: apiUser.updated_at || "",
  };
};

export const toAPIUser = (formData, existingUser = {}) => {
  const body = {
    firstname: formData.firstName,
    lastname: formData.lastName,
    email: formData.deliveryAddress,
    phone: formData.mobileNumber || undefined,
    sms_notification: formData.smsMode !== "Disabled",
    timezone: normalizeTimezone(formData.timeZone),
    user_status: formData.emailMode === "Enabled" ? "enabled" : "disabled",
  };

  if (!existingUser.userType || existingUser.userType === "console") {
    body.user_role = formData.userRole || existingUser.userRole || "viewer";
    body.user_type = "console";
  }

  if (formData.password) {
    body.password = formData.password;
  }

  return body;
};

export const toAPIUserUpdate = (formData, existingUser = {}) => {
  const resolvedStatus = formData.userStatus || existingUser.emailMode || "Enabled";

  const body = {
    firstname: formData.firstName,
    lastname: formData.lastName,
    phone: formData.mobileNumber || undefined,
    sms_notification: formData.smsMode !== "Disabled",
    timezone: normalizeTimezone(formData.timeZone || existingUser.timeZone),
    user_status: resolvedStatus === "Enabled" ? "enabled" : "disabled",
    two_fa_enabled: existingUser.twoFaEnabled ?? true,
  };

  if (!existingUser.userType || existingUser.userType === "console") {
    body.user_role = existingUser.userRole || "viewer";
  }

  return body;
};

export const toAPIUserStatusUpdate = (uiUser, status) => {
  const payload = {
    firstname: uiUser.firstName,
    lastname: uiUser.lastName,
    user_status: status,
    sms_notification: uiUser.smsMode !== "Disabled",
    timezone: normalizeTimezone(uiUser.timeZone),
    phone: uiUser.mobileNumber || undefined,
    two_fa_enabled: uiUser.twoFaEnabled,
  };

  if (!uiUser.userType || uiUser.userType === "console") {
    payload.user_role = uiUser.userRole || "viewer";
  }

  return payload;
};

export const extractUserList = (data) => {
  if (Array.isArray(data?.users)) return data.users;
  if (Array.isArray(data)) return data;
  return [];
};
